import React from "react";
import familyImg from "../../assets/images/Home/h-1.avif";
import doctorImg from "../../assets/images/Home/h-2.avif";

const HealthPrioritySection = () => {

  // 🎨 Luxury Theme
const colors = {
  sectionBg: "#F9FBFA",  // Logo ke Sage Green ka light version (Fresh & Clean)
  accent: "#D7A19E",     // Logo ka Muted Rose (Feminine & Caring)
  dark: "#546E7A",       // Logo ka Dark Slate Blue (Professional & Trust)
  text: "#4A5A64",       // Logo blue ka softer version (Reading ke liye best)
  border: "#C5B358",     // Logo ka Muted Gold (Premium feel)
  fontFamily: "'Poppins', sans-serif", // Correct way to declare font
};

  return (
    <section
      className="py-24 px-6 md:px-16 lg:px-32 relative overflow-hidden"
      style={{ backgroundColor: colors.sectionBg }}
    >
      <div className="max-w-6xl mx-auto">

        {/* ===== HEADING AREA ===== */}
        <div className="text-center mb-16">
          <span
            className="uppercase tracking-[0.3em] text-xs font-semibold"
            style={{ color: colors.accent }}
          >
            Our Commitment
          </span>

          <h2
            className="text-3xl md:text-4xl font-light mt-4"
            style={{ color: colors.dark }}
          >
            Your Health,{" "}
            <span style={{ color: colors.accent, fontWeight: 600 }}>
              Our Priority
            </span>
          </h2>

          {/* Accent Divider */}
          <div
            className="w-20 h-[2px] mx-auto mt-6"
            style={{ backgroundColor: colors.border }}
          />
        </div>

        {/* ===== CONTENT GRID ===== */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">

          {/* Images Side */}
          <div className="relative flex justify-center">

            <div className="relative">
              <img
                src={familyImg}
                alt="Happy family"
                className="rounded-3xl shadow-xl w-[350px] md:w-[420px] object-cover transition duration-500 hover:scale-105"
                style={{ border: `1px solid ${colors.border}` }}
              />

              <img
                src={doctorImg}
                alt="Doctor consultation"
                className="absolute -bottom-10 -right-10 rounded-3xl shadow-xl w-[250px] md:w-[300px] object-cover transition duration-500 hover:scale-105"
                style={{ border: `1px solid ${colors.border}` }}
              />
            </div>

          </div>

          {/* Text Side */}
          <div>
            <p
              className="text-lg leading-relaxed mb-8"
              style={{ color: colors.text }}
            >
              At Dr Vibha , we combine compassion with modern
              expertise to support women through every stage of life.
              From pregnancy care to fertility solutions, we are here
              to walk this journey with you.
            </p>

            <p
              className="text-base leading-relaxed"
              style={{ color: colors.text }}
            >
              Our approach blends advanced medical science with
              emotional support, ensuring every patient feels heard,
              respected, and confident in her healthcare decisions.
            </p>
          </div>

        </div>

      </div>
    </section>
  );
};

export default HealthPrioritySection;